const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className={`font-Inter text-center py-6 mt-auto`}>
      <p className="text-sm">
        <span className="orange">Copyright ©</span> {currentYear} Keloola by
        Thrive
      </p>
    </div>
  );
};

export default Footer;
